<template>
  <router-link
    tag="button"
    class="project"
    :to="{ name: 'timeControlShow', params: { id: project.id } }"
  >
    <div class="project_top">
      <div class="left">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div class="project_top_name f14 fw500" v-bind="attrs" v-on="on">
              {{ project.name }}
            </div>
          </template>
          <span>{{ project.name }}</span>
        </v-tooltip>
        <div class="number f12">
          {{ $clientProjectNumber({ project_id: project.id, year: project.year, project_number:project.project_number  }) }}
        </div>
      </div>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div class="project_top_client f14" v-bind="attrs" v-on="on">
            {{ project.client.name }}
          </div>
        </template>
        <span>{{ project.client.name }}</span>
      </v-tooltip>
    </div>
    <div :id="'scroll' + index" class="project_center">
      <TimeControlCardChart :works="formatedWorks" />
    </div>
    <div class="project_bot">
      <div class="project_bot_all f14">
        {{ formatDate(project.start_date) + ' - ' + formatDate(project.end_date) }}
      </div>
      <div class="project_bot_extra f14">
        {{ localStorage.translations.pages.common.text.additional_work }}:
        <span>{{ $formatTime(extra_works) }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
import TimeControlCardChart from 'components/timeControl/TimeControlCardChart'
export default {
  name: 'TimeControlCard',
  props: ['project', 'index', 'works', 'extra_works'],
  data() {
    return {}
  },
  components: {
    TimeControlCardChart,
  },
  created() {},
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
    formatedWorks() {
      let data = {}
      for (let i in this.works) {
        let work = this.works[i]
        if (!data[work.work_type.id]) {
          data[work.work_type.id] = {
            measure: work.measure,
            planned: Number(work.planned),
            work_type: work.work_type,
            is_hourly: work.is_hourly,
            done: 0
          }
        }
        for (let p in work.periods) {
          let period = work.periods[p]
          data[work.work_type.id].done += Number(period.done)
        }
      }
      return Object.values(data)
    },
  },
  mounted() {},
  methods: {
    wheel: function (ev) {
      let content = document.getElementById('scroll' + this.index)
      if (ev.deltaY < 0) {
        content.scrollLeft -= 40
      } else {
        content.scrollLeft += 40
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
  },
}
</script>

<style lang="scss" scoped>
.project {
  display: grid;
  row-gap: 20px;
  background: #ffffff;
  // padding: 16px;
  box-shadow: 0px 4px 4px rgba(37, 120, 173, 0.2);
  grid-template-rows: max-content auto max-content;
  border-radius: 4px;
  text-decoration: none;
  color: #2c2c2c;
  transition: 0.3s;
  &:hover {
    box-shadow: 0px 0px 16px rgba(67, 142, 184, 0.4);
  }
  &_top {
    display: grid;
    padding: 14px 16px;
    // grid-template-columns: 60% auto;
    grid-template-columns: 1fr;
    gap: 10px;
    justify-content: space-between;
    background: #277faf;
    color: #f2f2f2;
    border-radius: 4px 4px 0px 0px;
    &_name {
      text-align: start;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      color: inherit;
    }
    &_client {
      color: #bec9cf;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: inherit;
      align-self: flex-end;
      text-align: end;
    }
    .left {
      display: grid;
      justify-content: start;
      row-gap: 5px;
      color: inherit;
      .number {
        width: max-content;
        color: inherit;
      }
    }
  }
  &_center {
    overflow-y: hidden;
    padding: 20px 16px;
  }
  &_bot {
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    column-gap: 10px;
    justify-content: space-between;
    align-items: end;
    padding: 0 16px 16px;
    &_extra {
      justify-self: end;
      display: block;
      padding: 4px 8px;
      border: 1px solid #34c759;
      color: #34c759;
      width: max-content;
      border-radius: 4px;
      span {
        display: block;
      }
    }
    &_all {
      color: #858b8e;
      text-align: start;
    }
  }
}
</style>
